// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__oFGxl","content":"Consent_content__2ReHw","footer":"Consent_footer__2KHAx"};